
import { Component, Vue } from "vue-property-decorator";
import VerTramite from "@/components/Tramites/VerTramite.vue";

@Component({
  components: {
    VerTramite
  }
})
export default class VerTramitesView extends Vue {}
